import React from "react";

import * as Styled from "./styles";

export type PaginationProps = {
  currentPage: number;
};

const Pagination: React.FC<PaginationProps> = ({ currentPage }) => {
  return (
    <Styled.PaginationWrapper>
      <Styled.PageIndicator $active={currentPage === 1}></Styled.PageIndicator>
      <Styled.PageIndicator $active={currentPage === 2}></Styled.PageIndicator>
    </Styled.PaginationWrapper>
  );
};

export default Pagination;
